<picture *ngIf="bbImage">
  <source [srcset]="webpSrc" type="image/webp"/>
  <source [srcset]="imgSrc" [type]="bbImage.type"/>

  <img [src]="imgSrc"
       [attr.alt]="bbImage.alt" [attr.title]="bbImage.title"
       [attr.width]="width" [attr.height]="height"
       (load)="loadEvent.emit($event)"/>
</picture>
